import { apiClient } from '@/utils/api';

export interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  allDay: boolean;
  type: 'appointment' | 'practice_deadline' | 'activity';
  status?: string;
  client?: string;
  practice?: string;
  practiceId?: string;
  practiceType?: string;
  description?: string;
  location?: string;
  user?: string;
  color?: string;
  activityId?: string;
  appointmentId?: string;
}

// Le interfacce Appointment e PracticeDeadline sono ora contenute in CalendarEvent

export const calendarService = {
  async getCalendarEvents(startDate: string, endDate: string, clientId?: string, practiceId?: string, userId?: string) {
    const response = await apiClient.get('/calendar/events', {
      params: { startDate, endDate, clientId, practiceId, userId },
    });
    return response.data;
  },
};

